module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26241",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6654",
      "conversations-error-reporting": "static-1.7929",
      "conversations-internal-pub-sub": "static-1.15010",
      "conversations-internal-schema": "static-1.11637",
      "conversations-message-history": "static-1.10114",
      "conversations-test-sdk": "static-1.9468",
      "conversations-visitor-experience-components": "static-1.19604",
      "head-dlb": "static-1.4130",
      "hs-promise-utils": "static-1.4537",
      "hs-test-utils": "static-1.6999",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10522",
      "I18n": "static-7.1399",
      "jasmine-immutable": "static-1.1973",
      "jasmine-runner": "static-1.5426",
      "quartz": "static-1.5758",
      "react-aria": "static-1.40",
      "react-dlb": "static-1.55",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3546",
      "viral-links-lib": "static-1.5879",
      "visitor-ui-component-library": "static-1.5193",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3574",
      "atom": "static-1.4157",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3799",
      "conversations-infrastructure": "static-1.7942",
      "conversations-prop-types": "static-1.6455",
      "conversations-visibility-tools": "static-1.4781",
      "conversations-visitor-message-history": "static-1.18341",
      "cssUtils": "static-1.532",
      "enviro": "static-4.310",
      "flux-actions": "static-1.278",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.288",
      "raven": "static-3.4958",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15568",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4488",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3383",
      "sanitize-text": "static-1.7160",
      "signup-constants": "static-1.16716",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.466",
      "usage-tracker": "static-1.6471",
      "usage-tracker-core": "static-1.6321",
      "usage-tracker-multi": "static-1.4885",
      "usage-tracker-public": "static-1.6282",
      "visitor-ui-component-library-icons": "static-1.5004",
      "hs-promise-rejection-tracking": "static-1.4492",
      "raven-hubspot": "static-1.5265",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2623",
      "moment": "static-3.26",
      "quartz-core": "static-1.4977",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3906",
      "foundations-components": "static-1.6251",
      "foundations-theming": "static-1.3312",
      "UIComponents": "static-3.7469",
      "cv-backend-services": "static-1.1243",
      "immutable-less": "static-1.3566",
      "conversations-skeleton-state": "static-1.6372",
      "icons": "static-2.592",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.3741",
      "ui-images": "static-2.889",
      "permission-components": "static-1.4383",
      "react-virtualized": "static-2.75",
      "HeadJS": "static-2.584",
      "framer-motion": "static-1.42",
      "hs-test-utils-bend-plugin": "static-1.2110",
      "msw": "static-1.39",
      "testing-library": "static-1.123",
      "i18n-data": "static-1.199",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3355",
      "quartz-core-utils": "static-1.2625",
      "signup-ui-url-generator": "static-2.7060",
      "HubStyle": "static-2.10830",
      "sassPrefix": "static-1.133",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4888",
      "copilot-toolkit": "static-1.7426",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.657",
      "hub-http-shared-msw-handlers": "static-1.7317",
      "hubspotter-http": "static-1.3750",
      "hubspotter-http-shared-msw-handlers": "static-1.7315",
      "mobile-manifest-mixins": "static-1.355",
      "platform-navigation-bootstrap": "static-1.11430",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "hs-story-utils": "static-1.8371",
      "bend-plugin-foundations-components": "static-1.2520",
      "floating-ui": "static-1.30",
      "foundations-theming-specialty": "static-1.1029",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1795",
      "foundations-theming-base": "static-1.2297",
      "ts-schema": "static-1.3279",
      "chatspot-client-types": "static-1.9013",
      "chatspot-core": "static-1.16799",
      "platform-infra-nav-components": "static-1.6863"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26241",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6654",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7929",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15010",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11637",
      "conversations-message-history": "/conversations-message-history/static-1.10114",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9468",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19604",
      "head-dlb": "/head-dlb/static-1.4130",
      "hs-promise-utils": "/hs-promise-utils/static-1.4537",
      "hs-test-utils": "/hs-test-utils/static-1.6999",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10522",
      "I18n": "/I18n/static-7.1399",
      "jasmine-immutable": "/jasmine-immutable/static-1.1973",
      "jasmine-runner": "/jasmine-runner/static-1.5426",
      "quartz": "/quartz/static-1.5758",
      "react-aria": "/react-aria/static-1.40",
      "react-dlb": "/react-dlb/static-1.55",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3546",
      "viral-links-lib": "/viral-links-lib/static-1.5879",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5193",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3574",
      "atom": "/atom/static-1.4157",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3799",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7942",
      "conversations-prop-types": "/conversations-prop-types/static-1.6455",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4781",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18341",
      "cssUtils": "/cssUtils/static-1.532",
      "enviro": "/enviro/static-4.310",
      "flux-actions": "/flux-actions/static-1.278",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.288",
      "raven": "/raven/static-3.4958",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15568",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4488",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3383",
      "sanitize-text": "/sanitize-text/static-1.7160",
      "signup-constants": "/signup-constants/static-1.16716",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.466",
      "usage-tracker": "/usage-tracker/static-1.6471",
      "usage-tracker-core": "/usage-tracker-core/static-1.6321",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4885",
      "usage-tracker-public": "/usage-tracker-public/static-1.6282",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5004",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4492",
      "raven-hubspot": "/raven-hubspot/static-1.5265",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2623",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4977",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3906",
      "foundations-components": "/foundations-components/static-1.6251",
      "foundations-theming": "/foundations-theming/static-1.3312",
      "UIComponents": "/UIComponents/static-3.7469",
      "cv-backend-services": "/cv-backend-services/static-1.1243",
      "immutable-less": "/immutable-less/static-1.3566",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6372",
      "icons": "/icons/static-2.592",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.3741",
      "ui-images": "/ui-images/static-2.889",
      "permission-components": "/permission-components/static-1.4383",
      "react-virtualized": "/react-virtualized/static-2.75",
      "HeadJS": "/HeadJS/static-2.584",
      "framer-motion": "/framer-motion/static-1.42",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2110",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.123",
      "i18n-data": "/i18n-data/static-1.199",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3355",
      "quartz-core-utils": "/quartz-core-utils/static-1.2625",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7060",
      "HubStyle": "/HubStyle/static-2.10830",
      "sassPrefix": "/sassPrefix/static-1.133",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4888",
      "copilot-toolkit": "/copilot-toolkit/static-1.7426",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.657",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7317",
      "hubspotter-http": "/hubspotter-http/static-1.3750",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7315",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.355",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11430",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "hs-story-utils": "/hs-story-utils/static-1.8371",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2520",
      "floating-ui": "/floating-ui/static-1.30",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1029",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1795",
      "foundations-theming-base": "/foundations-theming-base/static-1.2297",
      "ts-schema": "/ts-schema/static-1.3279",
      "chatspot-client-types": "/chatspot-client-types/static-1.9013",
      "chatspot-core": "/chatspot-core/static-1.16799",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6863"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};